import { defineStore } from "pinia";

type CommonType = {
  isCollapse: boolean,
  sportVisitedViews: DefaultObjectType,
  lang: string,
  userData: DefaultObjectType,
  token: string,
  showComponent: boolean,
  excludePage: string,
  includePage: string[],
  addType: string[],
  traceDebugUrl: string,
  localIp: string,
  mac: string,
  traceDebugLoginData: any,
  showLogData: Object[],
  cacheData: DefaultObjectType
}

export const useCommon = defineStore('common', {
  state: (): CommonType => {
    return {
      // 侧边栏菜单折叠
      isCollapse: false,
      // 已打开的标签 todo:子应用要改一下这个名称，不然会保留其他子应用打开过的标签导致报错
      sportVisitedViews: [],

      // 语言标识
      lang: localStorage.getItem('language') || 'en',
      userData: {},
      token: sessionStorage.getItem("tokenValue"),
      showComponent: true,
      excludePage: '',
      includePage: [''],
      addType: [''],
      cacheData: {},

      // 直播接口调试保存的ip+端口
      traceDebugUrl: '',
      localIp: '',
      mac: '',
      traceDebugLoginData: {},
      showLogData: []
    }
  },
  actions: {
    setCacheData(data) {
      this.cacheData = data
    },

    addUserData(data: DefaultObjectType) {
      this.userData = data
    },
    addToken(data: string) {
      this.token = data
    },

    changeCollapse(flag: boolean) {
      this.isCollapse = flag
    },

    // 修改语言
    changeLang(lang: string) {
      this.lang = lang
    },

    addTagsView(tags: DefaultObjectType) {
      try {
        if (this.sportVisitedViews.some((tag: DefaultObjectType) => tag.path === tags.path)) {

        } else {
          this.sportVisitedViews.push(tags)
        }
      } catch (error) {
        console.log(error);
      }
    },

    delTagsView(tags: DefaultObjectType) {
      this.clearIncludePage(tags.name)
      this.sportVisitedViews.forEach((tag: DefaultObjectType, index: number | string) => {
        if (tag.meta.title === tags.meta.title) {
          tags.meta.keepAlive = false
          this.sportVisitedViews.splice(index, 1)
        }
      })
    },

    delOtherView(view: DefaultObjectType) {
      if (this.includePage.indexOf(view.name) > -1) {
        this.includePage = [this.includePage[this.includePage.indexOf(view.name)]]
      } else {
        this.includePage = ['']
      }
      this.sportVisitedViews = this.sportVisitedViews.filter((v: DefaultObjectType) => {
        return v.meta.affix || v.path === view.path
      })
    },

    delAllTagsView() {
      const affixTags = this.sportVisitedViews.filter((tag: DefaultObjectType) => tag.meta.affix)
      this.sportVisitedViews = affixTags
    },

    refreshCurrentPage(page) {
      this.excludePage = page
      this.showComponent = false
      setTimeout(() => {
        this.excludePage = ''
        this.showComponent = true
      })
    },

    setIncludePage(page) {
      if (this.includePage.indexOf(page) == -1) {
        this.includePage.push(page)
      }
    },

    clearIncludePage(page?) {
      if (page) {
        const idx = this.includePage.indexOf(page)
        if (idx > -1) {
          this.includePage.splice(idx, 1)
        }
      }
    },

    resetIncludePage() {
      this.includePage = ['']
    },

    setAddType(type) {
      if (this.addType.indexOf(type) == -1) {
        this.addType.push(type)
      }
    },

    removeAddType(type) {
      if (type) {
        const idx = this.addType.indexOf(type)
        if (idx > -1) {
          this.addType.splice(idx, 1)
        }
      }
    },

    clearAddType() {
      this.addType = []
    },

    addTraceDebugUrl(url) {
      this.traceDebugUrl = url
    },

    addIpAndMac(data) {
      this.localIp = data.localIp
      this.mac = data.mac
    },

    addTraceDebugLoginData(data) {
      this.traceDebugLoginData = data
    },

    addShowLogData(data) {
      this.showLogData.push(data)
    },
    clearShowLogData() {
      this.showLogData = []
    }
  }
})